import * as React from 'react'

type Props = {
  action: string
  onClickAction: () => void
}

const KeyboardAction = ({ action, onClickAction }: Props) => {
  const handleClick = () => {
    onClickAction()
  }
  const symbol = action === 'submit' ? '⏎' : '⌫'

  return (
    <div
      onClick={handleClick}
      className={`flex justify-around items-center mx-0.5 mt-1 h-12 w-[52px] cursor-pointer
        border border-solid border-gray-700 shadow-zinc-500 shadow-sm bg-gray-500 hover:border-gray-400
        text-2xl font-bold`}
    >
      {symbol}
    </div>
  )
}

export default KeyboardAction
